import { Sparkles, Wand2 } from 'lucide-react';
import MappingRow from './MappingRow';
import TemplateEditor from '../../../components/templateEditor/TemplateEditor';
import AiGenerator from '../../../components/aiGenerator/AiGenerator';
import { AiGenerationTypes } from '../../../enums/aiGenerationTypes';
import type { SqlQuerySectionProps } from './types';
import styles from './RequestMappingStep.module.css';

export default function SqlQuerySection({
  mappings,
  availableFields,
  canEdit,
  onUpdateMapping,
  onRemoveMapping,
  onGenerateSqlFromDb,
  sqlDbLoading,
  mainConnectionId,
  bodyTemplate,
  onBodyTemplateChange,
  onMakeDynamic,
  getOriginalValue,
  onMakeUndynamic,
  inputSchemaRaw,
  description,
  aiLoadingMapping,
  setAiLoadingMapping,
  onAiMappingResult,
}: SqlQuerySectionProps) {
  return (
    <>
      {/* 2. Auto Generate SQL from Input Fields */}
      {canEdit && availableFields.length > 0 && bodyTemplate !== '' && (
        <div className={styles.aiSection}>
          <AiGenerator
            icon={<Sparkles size={16} />}
            buttonText="Auto-generate SQL from input fields"
            prompt={`Generate SQL SELECT query for input fields: ${inputSchemaRaw}`}
            setContent={onAiMappingResult}
            loading={aiLoadingMapping}
            setAiLoading={setAiLoadingMapping}
            previousData={bodyTemplate}
            generateBody={{
              type: AiGenerationTypes.sqlQuery,
              description,
              context: { inputSchema: inputSchemaRaw, existingQuery: bodyTemplate },
            }}
          />
        </div>
      )}

      {/* 3. SQL Query textarea */}
      <div className={styles.advancedInner}>
        <TemplateEditor
          value={bodyTemplate}
          onChange={onBodyTemplateChange}
          onMakeDynamic={(info) => {
            setTimeout(() => {
              onMakeDynamic(info);
            }, 0);
          }}
          getOriginalValue={getOriginalValue}
          onMakeUndynamic={onMakeUndynamic}
          undynamicFallback="fieldName"
          height="250px"
          title="SQL Query"
          templateType="request"
          contentType="sql"
          placeholder="SELECT column1, column2 FROM TableName WHERE id = {{ id }}"
          readOnly={!canEdit}
        />
      </div>
        {/* 1. Mappings + action buttons row */}
      <div className={styles.mappingList}>
        {mappings.length > 0 && (
          <div className={styles.mappingHeaders}>
            <span className={styles.colHeader}>Query Param</span>
            <span className={styles.colHeaderArrow} />
            <span className={styles.colHeader}>Input Field</span>
          </div>
        )}
        {mappings.map(mapping => (
          <MappingRow
            key={mapping.id}
            mapping={mapping}
            availableFields={availableFields}
            canEdit={canEdit}
            canDelete={false}
            onChange={(updates) => onUpdateMapping(mapping.id, updates)}
            onRemove={() => onRemoveMapping(mapping.id)}
          />
        ))}
        {canEdit && (
          <div className={styles.sqlActionsRow}>
           {bodyTemplate === '' && (
            <button
              type="button"
              className={styles.generateSqlBtn}
              onClick={onGenerateSqlFromDb}
              disabled={sqlDbLoading || !mainConnectionId}
            >
              <Wand2 size={14} />
              {sqlDbLoading ? 'Generating...' : 'Generate SQL from DB + Description'}
            </button>
           )}
          </div>
        )}
      </div>

    </>
  );
}
